import { render, staticRenderFns } from "./IristarCarousel.vue?vue&type=template&id=6d088038&scoped=true&"
import script from "./IristarCarousel.vue?vue&type=script&lang=js&"
export * from "./IristarCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d088038",
  null
  
)

export default component.exports